import { Building2, TreePine, Shield } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const PlannedByDesignSection = () => {
  const { t } = useLanguage();
  const d = t.whyHuatulco;
  const icons = [Building2, TreePine, Shield];

  return (
    <section className="bg-[#2D2926] text-white" data-testid="planned-by-design-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-[0.3em] text-[#D4A03D] font-accent mb-4 block">{d.label3}</span>
          <h3 className="font-heading text-2xl md:text-3xl text-white mb-4">{d.title3}</h3>
          <p className="text-white/60 max-w-2xl mx-auto">{d.subtitle3}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {d.planningPoints.map((point, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="text-center p-6" data-testid={`planning-point-${i}`}>
                <div className="w-14 h-14 rounded-full bg-[#D4A03D]/20 flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-7 h-7 text-[#D4A03D]" />
                </div>
                <span className="text-white font-medium block mb-2">{point.title}</span>
                <span className="text-white/50 text-sm">{point.desc}</span>
              </div>
            );
          })}
        </div>
        <div className="text-center">
          <p className="font-heading text-xl md:text-2xl text-[#D4A03D]">{d.conclusion}</p>
        </div>
      </div>
    </section>
  );
};

export default PlannedByDesignSection;
